webpackJsonp([2],{

/***/ 100:
/***/ (function(module, exports) {

module.exports = {"appName":"MonkAI","headerNavigation":[{"name":"v1","path":"/home"}],"landingPage":"/home","topics":["news"],"pages":[{"route":"/home","name":"Home","description":"This is the documentation for MonkAI","icon":"address-book","children":[{"route":"/whatsNew","name":"Whats new?","description":"recent announcements, news, latest and greatest","icon":"bullhorn","topics":["news"],"markdown":"/static/markdown/Current.md"},{"route":"/demos","name":"Demos","description":"Examples and Projects built using MonkAI","icon":"bullhorn","topics":["demos"],"markdown":"/static/markdown/Demos.md"},{"route":"/codingstandards","name":"Coding Standards","description":"","topics":[],"icon":"question-circle","markdown":"/static/markdown/codingstandards.md"},{"route":"/contrib","name":"Contribution Guidelines","description":"","topics":[],"icon":"question-circle","markdown":"/static/markdown/contrib.md"},{"route":"/classification","name":"Image Classification","description":"Documentation for Image Classification algorithms","icon":"project-diagram","topics":["process"],"children":[{"route":"/tutorials","name":"Tutorials","description":"Blog Post, Jupyter Notebook, Reference Links.","icon":"project-diagram","topics":["Image Classification","Computer Vision","Deep Learning"],"markdown":"/static/markdown/classification/Tutorials.md"},{"route":"/pipelines","name":"Features","description":"Key Features within MonkAI","icon":"file-alt","topics":["process"],"children":[{"route":"/resume","name":"Resume Training","description":"temp","icon":"file-alt","topics":["Image CLassification","Computer Vision","Deep Learning"],"markdown":"/static/markdown/classification/Documentation.md"},{"route":"/copy","name":"Copy Experiment","description":"temp","icon":"file-alt","topics":["process"],"markdown":"/static/markdown/classification/Documentation.md"}]},{"route":"/modules","name":"Modules","description":"Implementation blocks for Image Classification","icon":"file-alt","topics":["process"],"markdown":"/static/markdown/detection/Modules.md"}]},{"route":"/detection","name":"Object Detection","description":"Low-code Object Detection pipelines","icon":"project-diagram","topics":["process"],"children":[{"route":"/tutorials","name":"Tutorials","description":"Ready to deploy use cases of Object Detection","icon":"project-diagram","topics":["Object Detection","Computer Vision","Deep Learning"],"markdown":"/static/markdown/detection/Tutorials.md"},{"route":"/pipelines","name":"Pipelines","description":"Available pipelines for Object Detection","icon":"file-alt","topics":["pipelines"],"children":[{"route":"/gluonfinetune","name":"GluonCV Finetune","description":"temp","icon":"file-alt","topics":["Object Detection","Computer Vision","Deep Learning"],"markdown":"/static/markdown/detection/pipelines/gluonfinetune.md"},{"route":"/pytorchapi","name":"Pytorch Finetune","description":"temp","icon":"file-alt","topics":["Object Detection","Computer Vision","Deep Learning"],"markdown":"/static/markdown/detection/pipelines/pytorchfinetune.md"},{"route":"/mxrcnn","name":"MXRCNN","description":"temp","icon":"file-alt","topics":["process"],"markdown":"/static/markdown/detection/pipelines/mxrcnn.md"},{"route":"/efficientdet","name":"Efficient Detection","description":"temp","icon":"file-alt","topics":["Object Detection","Computer Vision","Deep Learning"],"markdown":"/static/markdown/detection/pipelines/efficientdet.md"},{"route":"/retinanet","name":"RetinaNet-Pytorch","description":"temp","icon":"file-alt","topics":["Object Detection","Computer Vision","Deep Learning"],"markdown":"/static/markdown/detection/pipelines/retinanet.md"},{"route":"/cornernet","name":"CornerNet-Lite","description":"temp","icon":"file-alt","topics":["Object Detection","Computer Vision","Deep Learning"],"markdown":"/static/markdown/detection/pipelines/cornernet.md"},{"route":"/yolov3","name":"YOLOv3","description":"temp","icon":"file-alt","topics":["Object Detection","Computer Vision","Deep Learning"],"markdown":"/static/markdown/detection/pipelines/yolov3.md"}]},{"route":"/modules","name":"Modules","description":"Implementation blocks for Object Detection","icon":"file-alt","topics":["process"],"markdown":"/static/markdown/detection/Modules.md"}]},{"route":"/custom","name":"Custom Network Creator","description":"Documentation for Custom Neural Network Creator","icon":"project-diagram","topics":["process"],"markdown":"/static/markdown/process/networkbuilder.md"},{"route":"/studio","name":"MonkAI Studio","description":"Documentation for MonkAI Studio","icon":"project-diagram","topics":["process"],"children":[{"route":"/demos","name":"Demos","description":"Walkthroughs of Studio","icon":"project-diagram","topics":["process"],"markdown":"/static/markdown/studio/demos.md"},{"route":"/setup","name":"Setup","description":"How to setup Studio locally","icon":"project-diagram","topics":["process"],"markdown":"/static/markdown/studio/setup.md"}]},{"route":"/gsoc2020","name":"GSoC 2020","description":"Information, Ideas List, Projects, Mentors, Requirements and more.","icon":"project-diagram","topics":["process"],"children":[{"route":"/getstarted","name":"Getting Started","description":"","icon":"project-diagram","topics":["process"],"markdown":"/static/markdown/GettingStarted.md"},{"route":"/ideaslist","name":"Ideas List","description":"List of Project Ideas","icon":"project-diagram","topics":["process"],"markdown":"/static/markdown/ideas.md"},{"route":"/howtoapply","name":"How to Apply","description":"Information for Applicants","icon":"project-diagram","topics":["process"],"markdown":"/static/markdown/howtoapply.md"},{"route":"/getintouch","name":"Get in Touch","description":"","icon":"project-diagram","topics":["process"],"markdown":"/static/markdown/getintouch.md"},{"route":"/codingstandards","name":"Coding Standards","description":"","topics":[],"icon":"question-circle","markdown":"/static/markdown/codingstandards.md"},{"route":"/contrib","name":"Contribution Guidelines","description":"","topics":[],"icon":"question-circle","markdown":"/static/markdown/contrib.md"}]}]}]}

/***/ }),

/***/ 119:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Header_vue__ = __webpack_require__(51);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2a499365_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Header_vue__ = __webpack_require__(120);
var normalizeComponent = __webpack_require__(26)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Header_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2a499365_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Header_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 120:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{staticClass:"header"},[_c('div',{staticClass:"header__brand"},[_c('svg',{ref:"nav__open",staticClass:"header__hamburger",attrs:{"tabindex":"0","viewBox":"0 0 512 512","xmlns":"http://www.w3.org/2000/svg"},on:{"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.openNavigation($event)},"click":_vm.openNavigation}},[_c('path',{attrs:{"d":"M424 394H89a8 8 0 0 1 0-16h335a8 8 0 0 1 0 16zM424 265H89a8 8 0 0 1 0-16h335a8 8 0 0 1 0 16zM424 135H89a8 8 0 0 1 0-16h335a8 8 0 0 1 0 16z"}})]),_vm._v(" "),_c('span',{staticClass:"header__name"},[_vm._v(_vm._s(_vm.name)+" "),_c('b',[_vm._v("Playbook")])])]),_vm._v(" "),(_vm.isVisible || _vm.isDesktop)?_c('nav',{staticClass:"nav"},[_c('svg',{ref:"nav__close",staticClass:"nav__icon nav__icon--close",attrs:{"tabindex":"0","viewBox":"0 0 100 100","xmlns":"http://www.w3.org/2000/svg"},on:{"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.closeNavigation($event)},"click":_vm.closeNavigation}},[_c('path',{attrs:{"d":"M77.6 21.1l-28 28.1-28.1-28.1-1.9 1.9 28 28.1-28 28.1 1.9 1.9L49.6 53l28 28.1 2-1.9-28.1-28.1L79.6 23z"}})]),_vm._v(" "),_c('ul',{staticClass:"nav__list"},_vm._l((_vm.list),function(item){return _c('router-link',{key:item.path,staticClass:"nav__item",attrs:{"to":item.path}},[_vm._v(" "+_vm._s(item.name)+"\n        ")])}))]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 121:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('Header',{on:{"toggleMenu":_vm.toggleMenu}}),_vm._v(" "),_c('main',[_c('nav',{staticClass:"main__nav",class:{ active: _vm.isNavOpen }},[_c('div',{staticClass:"nav__search"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.searchKeywords),expression:"searchKeywords"}],staticClass:"nav__search-input",attrs:{"placeholder":"Type to search"},domProps:{"value":(_vm.searchKeywords)},on:{"keyup":_vm.search,"input":function($event){if($event.target.composing){ return; }_vm.searchKeywords=$event.target.value}}}),_vm._v(" "),(_vm.searchResultsVisible)?_c('svg',{staticClass:"nav__search-icon",attrs:{"tabindex":"0","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 52 52"},on:{"click":_vm.reset,"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.reset($event)}}},[_c('path',{attrs:{"d":"M26 0C11.664 0 0 11.663 0 26s11.664 26 26 26 26-11.663 26-26S40.336 0 26 0zm0 50C12.767 50 2 39.233 2 26S12.767 2 26 2s24 10.767 24 24-10.767 24-24 24z"}}),_c('path',{attrs:{"d":"M35.707 16.293a.999.999 0 0 0-1.414 0L26 24.586l-8.293-8.293a.999.999 0 1 0-1.414 1.414L24.586 26l-8.293 8.293a.999.999 0 1 0 1.414 1.414L26 27.414l8.293 8.293a.997.997 0 0 0 1.414 0 .999.999 0 0 0 0-1.414L27.414 26l8.293-8.293a.999.999 0 0 0 0-1.414z"}})]):_vm._e()]),_vm._v(" "),_c('vue-tree-navigation',{attrs:{"items":_vm.tocItems,"defaultOpenLevel":1}})],1),_vm._v(" "),(!_vm.searchResultsVisible)?_c('router-view'):_c('div',{staticClass:"container"},[(_vm.searchResults.length)?_c('h1',{staticClass:"results__heading"},[_vm._v(_vm._s(_vm.searchResults.length)+" results matching \""+_vm._s(_vm.searchKeywords)+"\"")]):_c('h1',{staticClass:"results__heading"},[_vm._v("No results matching \""+_vm._s(_vm.searchKeywords)+"\"")]),_vm._v(" "),_c('ul',{staticClass:"results__search"},_vm._l((_vm.searchResults),function(result,index){return _c('li',{key:index,staticClass:"result"},[_c('header',{staticClass:"result__header"},[_c('router-link',{attrs:{"to":result.path}},[_c('h2',{staticClass:"result__title"},[_vm._v(_vm._s(result.name))])]),_vm._v(" "),_vm._l((result.topics),function(topic,idx){return _c('span',{key:idx,staticClass:"tag",attrs:{"tabindex":"0"},on:{"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }_vm.searchTopic(topic)},"click":function($event){_vm.searchTopic(topic)}}},[_vm._v(_vm._s(topic))])})],2),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm._f("truncate")(result.text,300, '...')))])])}))])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 122:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_configManager__ = __webpack_require__(16);




__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: __WEBPACK_IMPORTED_MODULE_2__services_configManager__["a" /* default */].getRoutingConfig()
}));

/***/ }),

/***/ 16:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__pageConfig_json__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__pageConfig_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__pageConfig_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);





var DefaultPageRenderer = function DefaultPageRenderer() {
  return __webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, 129));
};
var metaMap = {};

/**
 * processElement - recursively walk through a given node and enrich it with some additional
 * properties (to bring vue-tree-navigation and VueRouter in sync)
 */
function processElement(node, parent) {
  // add fully qualified path and reference to component
  node.path = node.route;
  if (!parent) node.breadCrumb = [];else node.breadCrumb = JSON.parse(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(parent.breadCrumb));
  var parentPath = parent != null ? parent.path + node.route : '/';

  node.breadCrumb.push({
    name: node.name,
    path: parentPath
  });

  node.component = DefaultPageRenderer;
  if (parent != null) node.path = parent.path + node.route;

  // process all childs and extracts the tiles (the next level of childs)
  var tiles = [];
  if (node.children) {
    for (var i in node.children) {
      var child = node.children[i];
      tiles.push({
        name: child.name,
        description: child.description,
        path: node.path + child.route,
        icon: child.icon,
        bgColor: child.bgColor,
        owner: child.owner,
        topics: child.topics
      });
      processElement(child, node);
    }
  }

  // construct meta object we give to DefaultPageRenderer as part of the current route
  node.meta = {
    tiles: tiles.length > 0 ? tiles : null,
    name: node.name,
    description: node.description,
    markdown: node.markdown,
    icon: node.icon,
    bgColor: node.bgColor,
    owner: node.owner,
    topics: node.topics,
    breadCrumb: node.breadCrumb

    // store the meta data in our metaMap
  };metaMap[node.path] = node.meta;
}

/**
 * generateRoutingConfig - generates the routing for VueRouter out of the pageConfig.pages
 */
function generateRoutingConfig(baseConfig) {
  var pages = JSON.parse(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(baseConfig.pages));

  for (var i in pages) {
    var element = pages[i];
    processElement(element, null);
  }

  // configure the default landing page
  pages.push({
    path: '/',
    redirect: baseConfig.landingPage
  });
  return pages;
}

/* harmony default export */ __webpack_exports__["a"] = ({
  /**
   * getMetaById - gets the page metadata by a given id
   */
  getMetaById: function getMetaById(route) {
    return metaMap[route];
  },

  /**
   * generates the routing config based on the tree
   */
  getRoutingConfig: function getRoutingConfig() {
    var routingConfig = generateRoutingConfig(this.getBaseConfig());

    // add more components

    return routingConfig;
  },

  /**
   * getBaseConfig - returns the full json from pageConfig.json
   */
  getBaseConfig: function getBaseConfig() {
    return __WEBPACK_IMPORTED_MODULE_2__pageConfig_json___default.a;
  },

  /**
   * getPages - returns the pages section from base config (for vue-tree-navigation)
   */
  getPages: function getPages() {
    return this.getBaseConfig().pages;
  },

  /**
   * getStatus
   */
  getStatus: function getStatus() {
    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      var pathName = window.location.pathname;
      var path = pathName.substring(0, pathName.length - 1) + '/static/content.json';

      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get(path).then(function (response) {
        resolve(response.data);
      }).catch(function (error) {
        return reject(error);
      });
    });
  }

});

/***/ }),

/***/ 31:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_configManager__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Header__ = __webpack_require__(119);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app',
  data: function data() {
    return {
      baseUrl: 'https://pages.github.ibm.com/merlin/playbook/#',
      isNavOpen: false,
      tocItems: __WEBPACK_IMPORTED_MODULE_1__services_configManager__["a" /* default */].getPages(),
      content: [],
      searchResultsVisible: false,
      searchResults: null,
      searchKeywords: null
    };
  },

  components: {
    Header: __WEBPACK_IMPORTED_MODULE_2__components_Header__["a" /* default */]
  },
  created: function created() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_1__services_configManager__["a" /* default */].getStatus().then(function (data) {
      if (data !== undefined) _this.content = data;
    }).catch(function (error) {
      console.log('error', error);
    });
  },

  methods: {
    toggleMenu: function toggleMenu() {
      this.isNavOpen = !this.isNavOpen;
    },
    search: function search($event) {
      var _this2 = this;

      if (this.searchKeywords) {
        var query = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, this.$route.query, { search: this.searchKeywords });
        this.$router.push({ query: query });

        this.searchResultsVisible = true;
        var filter = 'topic:';
        if (this.searchKeywords.indexOf('topic:') > -1) {
          this.searchResults = this.content.filter(function (result) {
            var topics = (result.topics || []).map(function (topic) {
              return topic.toLowerCase();
            });

            var topicExists = false;

            for (var i = 0; i < topics.length; i++) {
              if (topics[i].indexOf(_this2.searchKeywords.toLowerCase().replace(filter, '')) > -1) {
                topicExists = true;
              }
            }

            return topicExists;
          });
        } else {
          this.searchResults = this.content.filter(function (result) {
            return (result.text || '').toLowerCase().indexOf(_this2.searchKeywords.toLowerCase()) > -1 || (result.name || '').toLowerCase().indexOf(_this2.searchKeywords.toLowerCase()) > -1;
          });
        }
      } else {
        var _query = this.$route.query;
        delete _query.search;
        this.$router.push({ query: _query });
        this.reset();
      }
    },
    searchTopic: function searchTopic(topic) {
      var filter = 'topic:' + topic;
      var query = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, this.$route.query, { search: filter });
      this.searchKeywords = filter;
      this.search();
      this.$router.push({ query: query });
    },
    reset: function reset() {
      this.searchResultsVisible = false;
      this.searchKeywords = '';
      this.searchResults = [];
    }
  },
  watch: {
    $route: {
      immediate: true,
      handler: function handler(val, oldVal) {
        var url = window.location.href;
        if (url.indexOf('?') > -1) {
          var queryString = url.substring(url.indexOf('?') + 1);
          var queryObj = JSON.parse('{"' + decodeURIComponent(queryString.replace(/&/g, '","').replace(/=/g, '": "')) + '"}');
          if (queryObj && queryObj.search) {
            this.searchKeywords = queryObj.search;
            this.search();
          }
        } else {
          this.searchKeywords = '';
          this.searchResultsVisible = false;
        }
      }
    }
  }
});

/***/ }),

/***/ 51:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_configManager__ = __webpack_require__(16);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'header-component',
  data: function data() {
    return {
      isVisible: false,
      isDesktop: false,
      name: __WEBPACK_IMPORTED_MODULE_0__services_configManager__["a" /* default */].getBaseConfig().appName,
      list: __WEBPACK_IMPORTED_MODULE_0__services_configManager__["a" /* default */].getBaseConfig().headerNavigation
    };
  },

  created: function created() {
    if (window.innerWidth >= 780) {
      this.isDesktop = true;
    }
    window.addEventListener('resize', this.handleResize);
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
  },
  methods: {
    handleResize: function handleResize(event) {
      if (event.currentTarget.innerWidth >= 780) {
        this.isDesktop = true;
      } else {
        this.isDesktop = false;
      }
    },
    openNavigation: function openNavigation() {
      this.$emit('toggleMenu');
    },
    closeNavigation: function closeNavigation(event) {
      this.$emit('toggleMenu');
    }
  }
});

/***/ }),

/***/ 58:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_tree_navigation__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_tree_navigation___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_tree_navigation__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__fortawesome_fontawesome_svg_core__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__fortawesome_vue_fontawesome__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__fortawesome_vue_fontawesome___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__fortawesome_vue_fontawesome__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__fortawesome_free_solid_svg_icons__ = __webpack_require__(126);









__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_3_vue_tree_navigation___default.a);
__WEBPACK_IMPORTED_MODULE_4__fortawesome_fontawesome_svg_core__["library"].add(__WEBPACK_IMPORTED_MODULE_6__fortawesome_free_solid_svg_icons__["l" /* faBullhorn */], __WEBPACK_IMPORTED_MODULE_6__fortawesome_free_solid_svg_icons__["_23" /* faUniversalAccess */], __WEBPACK_IMPORTED_MODULE_6__fortawesome_free_solid_svg_icons__["_8" /* faQuestionCircle */], __WEBPACK_IMPORTED_MODULE_6__fortawesome_free_solid_svg_icons__["W" /* faMapMarkedAlt */], __WEBPACK_IMPORTED_MODULE_6__fortawesome_free_solid_svg_icons__["_7" /* faProjectDiagram */], __WEBPACK_IMPORTED_MODULE_6__fortawesome_free_solid_svg_icons__["_28" /* faUsersCog */], __WEBPACK_IMPORTED_MODULE_6__fortawesome_free_solid_svg_icons__["L" /* faGlobe */], __WEBPACK_IMPORTED_MODULE_6__fortawesome_free_solid_svg_icons__["G" /* faFileInvoice */], __WEBPACK_IMPORTED_MODULE_6__fortawesome_free_solid_svg_icons__["H" /* faFileSignature */], __WEBPACK_IMPORTED_MODULE_6__fortawesome_free_solid_svg_icons__["_12" /* faShareSquare */], __WEBPACK_IMPORTED_MODULE_6__fortawesome_free_solid_svg_icons__["U" /* faLightbulb */], __WEBPACK_IMPORTED_MODULE_6__fortawesome_free_solid_svg_icons__["_14" /* faSitemap */], __WEBPACK_IMPORTED_MODULE_6__fortawesome_free_solid_svg_icons__["_27" /* faUsers */], __WEBPACK_IMPORTED_MODULE_6__fortawesome_free_solid_svg_icons__["C" /* faEnvelopeSquare */], __WEBPACK_IMPORTED_MODULE_6__fortawesome_free_solid_svg_icons__["B" /* faEnvelope */], __WEBPACK_IMPORTED_MODULE_6__fortawesome_free_solid_svg_icons__["_22" /* faTimes */], __WEBPACK_IMPORTED_MODULE_6__fortawesome_free_solid_svg_icons__["_19" /* faThList */], __WEBPACK_IMPORTED_MODULE_6__fortawesome_free_solid_svg_icons__["O" /* faHandshake */], __WEBPACK_IMPORTED_MODULE_6__fortawesome_free_solid_svg_icons__["A" /* faEdit */], __WEBPACK_IMPORTED_MODULE_6__fortawesome_free_solid_svg_icons__["_11" /* faSearch */], __WEBPACK_IMPORTED_MODULE_6__fortawesome_free_solid_svg_icons__["Y" /* faMicroscope */], __WEBPACK_IMPORTED_MODULE_6__fortawesome_free_solid_svg_icons__["v" /* faComments */], __WEBPACK_IMPORTED_MODULE_6__fortawesome_free_solid_svg_icons__["T" /* faLanguage */], __WEBPACK_IMPORTED_MODULE_6__fortawesome_free_solid_svg_icons__["_4" /* faPeopleCarry */], __WEBPACK_IMPORTED_MODULE_6__fortawesome_free_solid_svg_icons__["j" /* faBug */], __WEBPACK_IMPORTED_MODULE_6__fortawesome_free_solid_svg_icons__["_25" /* faUserClock */], __WEBPACK_IMPORTED_MODULE_6__fortawesome_free_solid_svg_icons__["_1" /* faPaperclip */], __WEBPACK_IMPORTED_MODULE_6__fortawesome_free_solid_svg_icons__["c" /* faBell */], __WEBPACK_IMPORTED_MODULE_6__fortawesome_free_solid_svg_icons__["q" /* faClipboard */], __WEBPACK_IMPORTED_MODULE_6__fortawesome_free_solid_svg_icons__["P" /* faHeadset */], __WEBPACK_IMPORTED_MODULE_6__fortawesome_free_solid_svg_icons__["_26" /* faUserTie */], __WEBPACK_IMPORTED_MODULE_6__fortawesome_free_solid_svg_icons__["R" /* faIdCard */], __WEBPACK_IMPORTED_MODULE_6__fortawesome_free_solid_svg_icons__["E" /* faExclamationTriangle */], __WEBPACK_IMPORTED_MODULE_6__fortawesome_free_solid_svg_icons__["s" /* faCogs */], __WEBPACK_IMPORTED_MODULE_6__fortawesome_free_solid_svg_icons__["_15" /* faSlidersH */], __WEBPACK_IMPORTED_MODULE_6__fortawesome_free_solid_svg_icons__["f" /* faBook */], __WEBPACK_IMPORTED_MODULE_6__fortawesome_free_solid_svg_icons__["F" /* faFileAlt */], __WEBPACK_IMPORTED_MODULE_6__fortawesome_free_solid_svg_icons__["_18" /* faThLarge */], __WEBPACK_IMPORTED_MODULE_6__fortawesome_free_solid_svg_icons__["w" /* faCopy */], __WEBPACK_IMPORTED_MODULE_6__fortawesome_free_solid_svg_icons__["a" /* faArchway */], __WEBPACK_IMPORTED_MODULE_6__fortawesome_free_solid_svg_icons__["e" /* faBolt */], __WEBPACK_IMPORTED_MODULE_6__fortawesome_free_solid_svg_icons__["z" /* faDesktop */], __WEBPACK_IMPORTED_MODULE_6__fortawesome_free_solid_svg_icons__["n" /* faChartBar */], __WEBPACK_IMPORTED_MODULE_6__fortawesome_free_solid_svg_icons__["y" /* faDatabase */], __WEBPACK_IMPORTED_MODULE_6__fortawesome_free_solid_svg_icons__["_9" /* faRetweet */], __WEBPACK_IMPORTED_MODULE_6__fortawesome_free_solid_svg_icons__["Q" /* faHeart */], __WEBPACK_IMPORTED_MODULE_6__fortawesome_free_solid_svg_icons__["_30" /* faWrench */], __WEBPACK_IMPORTED_MODULE_6__fortawesome_free_solid_svg_icons__["t" /* faColumns */], __WEBPACK_IMPORTED_MODULE_6__fortawesome_free_solid_svg_icons__["_0" /* faPaperPlane */], __WEBPACK_IMPORTED_MODULE_6__fortawesome_free_solid_svg_icons__["D" /* faExchangeAlt */], __WEBPACK_IMPORTED_MODULE_6__fortawesome_free_solid_svg_icons__["S" /* faKey */], __WEBPACK_IMPORTED_MODULE_6__fortawesome_free_solid_svg_icons__["_21" /* faThumbsUp */], __WEBPACK_IMPORTED_MODULE_6__fortawesome_free_solid_svg_icons__["_20" /* faThumbsDown */], __WEBPACK_IMPORTED_MODULE_6__fortawesome_free_solid_svg_icons__["_2" /* faPaste */], __WEBPACK_IMPORTED_MODULE_6__fortawesome_free_solid_svg_icons__["V" /* faLink */], __WEBPACK_IMPORTED_MODULE_6__fortawesome_free_solid_svg_icons__["g" /* faBookReader */], __WEBPACK_IMPORTED_MODULE_6__fortawesome_free_solid_svg_icons__["_10" /* faRobot */], __WEBPACK_IMPORTED_MODULE_6__fortawesome_free_solid_svg_icons__["_17" /* faTaxi */], __WEBPACK_IMPORTED_MODULE_6__fortawesome_free_solid_svg_icons__["x" /* faCubes */], __WEBPACK_IMPORTED_MODULE_6__fortawesome_free_solid_svg_icons__["_3" /* faPencilAlt */], __WEBPACK_IMPORTED_MODULE_6__fortawesome_free_solid_svg_icons__["_13" /* faSignal */], __WEBPACK_IMPORTED_MODULE_6__fortawesome_free_solid_svg_icons__["p" /* faCheck */], __WEBPACK_IMPORTED_MODULE_6__fortawesome_free_solid_svg_icons__["I" /* faFileWord */], __WEBPACK_IMPORTED_MODULE_6__fortawesome_free_solid_svg_icons__["_6" /* faPlusSquare */], __WEBPACK_IMPORTED_MODULE_6__fortawesome_free_solid_svg_icons__["X" /* faMapSigns */], __WEBPACK_IMPORTED_MODULE_6__fortawesome_free_solid_svg_icons__["h" /* faBox */], __WEBPACK_IMPORTED_MODULE_6__fortawesome_free_solid_svg_icons__["_24" /* faUser */], __WEBPACK_IMPORTED_MODULE_6__fortawesome_free_solid_svg_icons__["d" /* faBirthdayCake */], __WEBPACK_IMPORTED_MODULE_6__fortawesome_free_solid_svg_icons__["k" /* faBuilding */], __WEBPACK_IMPORTED_MODULE_6__fortawesome_free_solid_svg_icons__["u" /* faCommentAlt */], __WEBPACK_IMPORTED_MODULE_6__fortawesome_free_solid_svg_icons__["m" /* faChartArea */], __WEBPACK_IMPORTED_MODULE_6__fortawesome_free_solid_svg_icons__["N" /* faHandsHelping */], __WEBPACK_IMPORTED_MODULE_6__fortawesome_free_solid_svg_icons__["i" /* faBoxes */], __WEBPACK_IMPORTED_MODULE_6__fortawesome_free_solid_svg_icons__["J" /* faFire */], __WEBPACK_IMPORTED_MODULE_6__fortawesome_free_solid_svg_icons__["b" /* faAward */], __WEBPACK_IMPORTED_MODULE_6__fortawesome_free_solid_svg_icons__["M" /* faGraduationCap */], __WEBPACK_IMPORTED_MODULE_6__fortawesome_free_solid_svg_icons__["_5" /* faPhoneSquare */], __WEBPACK_IMPORTED_MODULE_6__fortawesome_free_solid_svg_icons__["_16" /* faTasks */], __WEBPACK_IMPORTED_MODULE_6__fortawesome_free_solid_svg_icons__["Z" /* faMousePointer */], __WEBPACK_IMPORTED_MODULE_6__fortawesome_free_solid_svg_icons__["_29" /* faWindowClose */], __WEBPACK_IMPORTED_MODULE_6__fortawesome_free_solid_svg_icons__["r" /* faClone */], __WEBPACK_IMPORTED_MODULE_6__fortawesome_free_solid_svg_icons__["o" /* faChartLine */], __WEBPACK_IMPORTED_MODULE_6__fortawesome_free_solid_svg_icons__["K" /* faFlag */]);

var filter = function filter(text, length, clamp) {
  clamp = clamp || '...';
  var node = document.createElement('div');
  node.innerHTML = text;
  var content = node.textContent;
  return content.length > length ? content.slice(0, length) + clamp : content;
};

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].filter('truncate', filter);

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('font-awesome-icon', __WEBPACK_IMPORTED_MODULE_5__fortawesome_vue_fontawesome__["FontAwesomeIcon"]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  render: function render(h) {
    return h(__WEBPACK_IMPORTED_MODULE_1__App__["a" /* default */]);
  }
});

/***/ }),

/***/ 61:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__(31);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5fb9f7c2_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__(121);
function injectStyle (ssrContext) {
  __webpack_require__(62)
}
var normalizeComponent = __webpack_require__(26)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5fb9f7c2_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 62:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })

},[58]);


// WEBPACK FOOTER //
// static/js/app.7f71122e4069bd165208.js